import { Component } from '@angular/core';
import { SharedService } from '../shared-service';
@Component({
  moduleId: module.id,
  selector: 'extra-layout',
  templateUrl: 'extra.component.html',
  styleUrls: ['extra.component.scss'],
  providers: [ SharedService ]
})
export class ExtraLayoutComponent {
  rtl: boolean;

  constructor( ) {
    this.rtl = false;
  }
}


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/layouts/extra/extra.component.ts